import sort from './sort'

const main = [
  {
    title: 'Cadastramento inicial',
    icon: 'task_alt',
    route: 'controle-cadastramento-details',
    disabled: false
  },
  {
    title: 'Eventos periódicos',
    icon: 'history',
    route: 'controle-eventos-details',
    disabled: false
  }
]

export default () => sort('title', main)
